import { APPOINTMENT_STATUS } from '../constants';
import { Appointment } from 'data';

type GroupedAppointments = Record<string, Appointment[]>;
type SeparatedGroupedAppointments = {
  upcoming: GroupedAppointments;
  rejected: GroupedAppointments;
};

const groupAndSeparateAppointmentsByDate = (
  appointments: Appointment[] = []
): SeparatedGroupedAppointments => {
  const grouped = appointments.reduce((acc, appointment) => {
    if (!acc[appointment.date]) {
      acc[appointment.date] = [];
    }
    acc[appointment.date].push(appointment);
    return acc;
  }, {} as GroupedAppointments);

  const upcoming: GroupedAppointments = {};
  const rejected: GroupedAppointments = {};

  Object.entries(grouped).forEach(([date, appts]) => {
    const upcomingForDate = appts.filter((a) => a.status !== APPOINTMENT_STATUS.SCHEDULED_REJECTED);
    const rejectedForDate = appts.filter((a) => a.status === APPOINTMENT_STATUS.SCHEDULED_REJECTED);

    if (upcomingForDate.length) {
      upcoming[date] = upcomingForDate;
    }

    if (rejectedForDate.length) {
      rejected[date] = rejectedForDate;
    }
  });

  return { upcoming, rejected };
};

export { groupAndSeparateAppointmentsByDate };
